var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{attrs:{"is-loading":_vm.loading,"fullPage":true,"color":"primary"}},[_c('driver-state',{attrs:{"driverStates":_vm.driverStates,"statusesFiltering":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }